import styled from "@emotion/styled";
import { Button, PageTable, Title } from "@src/components";
import React, { useEffect, useState } from "react";
import {
    getExpertSettlementListParams,
    useExpertSettlementList,
    usePayOutExpertSettlement,
} from "@src/hooks/queries/useExpertApprovalList";

import ExpertSettlementFilter from "./ExpertSettlementFilter";
import { getExpertSettlementListColumns } from "./ExpertSettlementListColumns";
const initParams: getExpertSettlementListParams = {
    page: 1,
    limit: 10,
    searchStartDate: "",
    searchEndDate: "",
};

const ExpertSettlementList = () => {
    const [params, setParams] = useState<getExpertSettlementListParams>(initParams);

    const { data, refetch: refetchSettlementList } = useExpertSettlementList(params);
    const { mutate: payOutExpertSettlement } = usePayOutExpertSettlement();

    const columns = getExpertSettlementListColumns({
        statusList:
            data?.list.map((item) => ({
                no: item.no,
                value: item.status,
            })) ?? [],
        onPayOut: (settlementLedgerNo: number) => {
            payOutExpertSettlement(settlementLedgerNo, {
                onSuccess: () => {
                    refetchSettlementList();
                    alert("정산 및 전문가 알림 전송이 완료되었습니다");
                },
                onError: () => {
                    alert("정산 지급 실패");
                },
            });
        },
    });
    useEffect(() => {
        refetchSettlementList();
    }, []);

    return (
        <>
            <StyledExpertUserList>
                <Title title="전문가 정산 관리" />
                <ExpertSettlementFilter filters={params} setFilters={setParams} />
                <div className="filterBtnBox">
                    <Button
                        color="gray"
                        handleClick={() => {
                            setParams(initParams);
                            refetchSettlementList();
                        }}
                        label="전체 해제"
                        size="medium"
                    />
                    <Button
                        color="purple"
                        handleClick={() => {
                            console.log("params", params);
                            if (
                                (Object.hasOwn(params, "searchValue") && !Object.hasOwn(params, "searchType")) ||
                                (Object.hasOwn(params, "searchType") && !Object.hasOwn(params, "searchValue"))
                            ) {
                                alert("검색 조건과 키워드를 확인해주세요");
                                return;
                            }
                            refetchSettlementList();
                        }}
                        label="검색"
                        size="medium"
                        isDisabled={false}
                    />
                </div>

                <div className="tableDiv">
                    <PageTable
                        columns={columns}
                        data={data?.list ?? []}
                        initialState={{
                            pageIndex: 0,
                            pageSize: 10,
                        }}
                        FixedHeight={500}
                        showTotalCount={true}
                        totalCount={data?.list.length ?? 0}
                        handlePageChange={(index: number) => {
                            const page = index + 1;
                            setParams({
                                ...params,
                                page,
                            });
                        }}
                    />
                </div>
            </StyledExpertUserList>
        </>
    );
};

export default ExpertSettlementList;

const StyledExpertUserList = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 40px;

    .filterBtnBox {
        display: flex;
        gap: 10px;
        flex-direction: row;
        justify-content: flex-end;
        padding-top: 10px;
    }
    .tableDiv {
        margin-top: 60px;
        position: relative;
    }

    .selectBtnBox {
        position: absolute;
        top: 0;
        right: 0;
        display: flex;
        gap: 10px;
        flex-direction: row;
        padding-top: 10px;
    }
`;

const FlexBox = styled.div`
    display: flex;
    flex-direction: row;
    gap: 10px;
`;

const FlexColumnBox = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
`;
